import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GettingStartedService {
  private baseUrl = environment.dataServicesURL + 'manage/getting-started/checklist';

  constructor(private http: HttpClient) {}

  checkItem(itemId: number): Observable<number[]> {
    return this.http.post<number[]>(`${this.baseUrl}/${itemId}`, null, { withCredentials: true });
  }

  uncheckItem(itemId: number): Observable<number[]> {
    return this.http.delete<number[]>(`${this.baseUrl}/${itemId}`, { withCredentials: true });
  }
}
